import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "icon"];

  declare readonly panelTarget: HTMLElement;
  declare readonly iconTarget: HTMLElement;

  toggle(): void {
    this.panelTarget.classList.toggle("hidden");

    if (this.panelTarget.classList.contains("hidden")) {
      this.iconTarget.textContent = "expand_more";
    } else {
      this.iconTarget.textContent = "expand_less";
    }
  }
}
